
import { ADMIN_BILLING, ADMIN_PRODUCT, CAN_LOGIN, EDIT_INSTANCE, SUPER_ADMIN, VIEW_SETTINGS } from "./permissions";

const data = [
    {
      id: "home",
      icon: "dashboard-1",
      caption: "Home",
      to: "/dashboard",
      title: "Dashboard",
      description: " Feradel license dashboard and control center",
      display: [],
      permissions: [CAN_LOGIN],
      contains: {
        indent: 0,
        items: [
          {
            id: "super_admin",
            icon: "shield",
            caption: "Admin",
            to: "/super-admin",
            exact: true,
            title: "Administrator",
            description: "Cross-licensee operations and oversight",
            display: ["Sidebar", "Mobile"],
            permissions: [SUPER_ADMIN],
          },
          {
            id: "my_products",
            icon: "grid-2",
            caption: "My Products",
            to: "/dashboard",
            exact: true,
            title: "My Products",
            description: "Your licensed Feradel products",
            display: ["Sidebar", "Mobile"],
            permissions: [CAN_LOGIN],
          },
          {
            id: "my_profile",
            icon: "user",
            caption: "My Profile",
            to: "/dashboard/profile/me",
            title: "My Profile",
            description: "Biographical information about you",
            display: ["Sidebar"],
            permissions: [CAN_LOGIN],
          },
          {
            id: "view_products",
            icon: "folder",
            caption: "Product",
            to: "/dashboard/products/:id",
            title: "Product",
            description: "product information",
            pageContext: "product-editor",
            display: [],
            permissions: [ADMIN_PRODUCT]
          },
          {
            id: "view_billing_history",
            icon: "file-text",
            caption: "Billing History",
            to: "/dashboard/billing/history",
            title: "Billing History",
            description: "Invoices and payment history",
            display: ["Sidebar", "Mobile"],
            permissions: [ADMIN_BILLING],
          },
          {
            id: "view_billing_methods",
            icon: "credit-card",
            caption: "Payment Methods",
            to: "/dashboard/billing/methods",
            title: "Payment methods",
            pageContext: "payment-method-editor",
            display: ["Sidebar", "Mobile"],
            permissions: [ADMIN_BILLING],
          },
          {
            id: "orders",
            icon: "file-data",
            caption: "Orders",
            to: "/dashboard/orders",
            title: "Orders",
            description: "License orders and processing status",
            display: ["Sidebar", "Mobile"],
            permissions: [EDIT_INSTANCE],
          },
          {
            id: "notifications",
            icon: "bell",
            caption: "Notifications",
            to: "/dashboard/notifications",
            title: "Notifications",
            description: "Your notification history",
            display: [],
            permissions: [CAN_LOGIN],
          },
          {
            id: "administration",
            icon: "settings-1",
            caption: "Settings",
            to: "/dashboard/settings",
            title: "Settings",
            description: "Settings items",
            display: ["Sidebar"],
            permissions: [VIEW_SETTINGS],
            nocrumb: true,
            contains: {
              indent: 1,
              items: [
                {
                  id: "settings_areas",
                  icon: "usa-map",
                  caption: "Areas",
                  to: "/dashboard/settings/areas",
                  title: "Areas",
                  description: "Area settings",
                  display: ["Sidebar"],
                  permissions: [VIEW_SETTINGS],
                },
                {
                  id: "settings_area_editor",
                  icon: "usa-map",
                  caption: "Area",
                  to: "/dashboard/settings/areas/:id",
                  title: "Area",
                  description: "Area information",
                  display: [],
                  permissions: [VIEW_SETTINGS],
                },
                {
                  id: "settings_products",
                  icon: "grid-2",
                  caption: "Products",
                  to: "/dashboard/settings/products",
                  title: "Products",
                  description: "Product settings",
                  display: ["Sidebar"],
                  permissions: [VIEW_SETTINGS],
                },
                {
                  id: "settings_product_editor",
                  icon: "grid-2",
                  caption: "Product",
                  to: "/dashboard/settings/products/:id",
                  title: "Product",
                  description: "Product information",
                  pageContext: "settings-product-editor",
                  display: [],
                  permissions: [VIEW_SETTINGS],
                }
              ]
            }
          }
        ]
      }
    }
  ];
  
  export default data;
  
  
